import React from 'react';
import clsx from 'clsx';
import { SanityLink } from '../../../../graphql-types';
import { formatLink } from '../../../helpers/format-link';
import { DynamicLink } from './dynamic-link';
import { useLanguage } from '../../../i18n';

type SanityLinkListProps = {
    links?: SanityLink[];
    isBackgroundDark?: boolean;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
};

export const SanityLinkList = ({
    links,
    size = 'md',
    isBackgroundDark = false,
    className = '',
}: SanityLinkListProps) => {
    const language = useLanguage();

    const formattedLinks = links
        ?.map(link => {
            return formatLink({
                ...link,
                isBackgroundDark,
                language,
            });
        })
        .filter(Boolean);

    if (!formattedLinks || formattedLinks?.length === 0) {
        return null;
    }

    return (
        <ul className={clsx('flex flex-wrap gap-x-4 items-center', className)}>
            {formattedLinks?.map((link, index) => {
                return (
                    <li key={index}>
                        <DynamicLink {...link} size={size} />
                    </li>
                );
            })}
        </ul>
    );
};
